import React from 'react';

function Team({ language, t }) {
  const isArabic = language === 'ar';

  const teamMembers = [
    {
      name: t.omerOral,
      title: t.founderLawyer,
      bio: t.omerBio,
      specialties: [t.taxLaw, t.commercialLaw, 'الاستشارة']
    },
    {
      name: t.rumeysa,
      title: t.founderLawyer,
      bio: t.rumeyBio,
      specialties: [t.familyLaw, t.inheritanceLaw, t.consumerLaw]
    },
    {
      name: t.suzi,
      title: t.founderCat,
      bio: t.suziBio,
      specialties: [t.moralSupport, t.stressManagement, t.officeculture]
    }
  ];

  return (
    <main className="team" dir={isArabic ? 'rtl' : 'ltr'}>
      <section className="page-header">
        <h1>{t.ourTeam}</h1>
        <p>{t.professionalMeeting}</p>
      </section>

      <section className="team-members">
        <div className="members-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="member-card">
              <div className="member-header">
                <h3>{member.name}</h3>
                <p className="title">{member.title}</p>
              </div>
              <p className="bio">{member.bio}</p>
              <div className="specialties">
                <h4>{t.specializations}:</h4>
                <ul>
                  {member.specialties.map((specialty, idx) => (
                    <li key={idx}>{specialty}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="team-values">
        <h2>{t.ourValues}</h2>
        <div className="values-grid">
          <div className="value-item">
            <h3>{t.independence}</h3>
            <p>{t.independenceDesc}</p>
          </div>
          <div className="value-item">
            <h3>{t.ethics}</h3>
            <p>{t.ethicsDesc}</p>
          </div>
          <div className="value-item">
            <h3>{t.professionalism}</h3>
            <p>{t.professionalismDesc}</p>
          </div>
          <div className="value-item">
            <h3>{t.reliability}</h3>
            <p>{t.reliabilityDesc}</p>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Team;
